import React, { Children, useState } from 'react'
import Tabs from '@mui/material/Tabs'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import { renderCountBadge } from 'components/custom/AdxLabelRenderer'

const AdxTabsBadge = ({
  initialValue = 0,
  whiteBackground,
  tabsBorderBottom,
  sxTabs,
  scrollButtons = true,
  sxPanel,
  children,
  setTabIndex,
  addButton,
  headerAction,
  searchParams,
  queryParams,
  ...rest
}) => {
  const [value, setValue] = useState(queryParams || initialValue)
  const handleChange = (event, newValue) => {
    setValue(newValue)
    if (searchParams) {
      searchParams({ type: newValue })
    }
  }
  const arrayChildren = Children.toArray(children)
  const activeValue = queryParams !== undefined && queryParams !== null ? queryParams : value

  const tabClick = (index) => {
    if (setTabIndex) {
      setTabIndex(index)
    } else {
      return null
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: 1, ...sxTabs }}>
      <Box
        {...rest}
        boxSizing="border-box"
        display={'flex'}
        flexDirection={'row'}
        sx={{
          borderBottom: 1,
          borderColor: 'gray-line.main',
        }}
      >
        <Tabs
          value={activeValue}
          onChange={handleChange}
          scrollButtons={scrollButtons}
          variant="scrollable"
          allowScrollButtonsMobile
          TabIndicatorProps={{
            sx: {
              backgroundColor: 'alternate.main',
              height: '2.5px',
            },
          }}
          TabScrollButtonProps={{
            sx: {
              border: 1,
              borderColor: 'gray-line.main',
              width: 30,
              my: 1,
              mx: 1,
              borderRadius: '4.5px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
          }}
        >
          {arrayChildren.map((item, index) => (
            <Tab
              key={index}
              value={index}
              onClick={(e) => {
                e.stopPropagation()
                tabClick(index)
              }}
              sx={{
                fontSize: '16px',
                fontSizeLg: '16px',
                borderTopRightRadius: '10px',
                borderTopLeftRadius: '10px',
              }}
              label={
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                  <Typography
                    variant="body1"
                    color={activeValue === index ? 'alternate.main' : 'light-gray-text.main'}
                    fontWeight="medium"
                  >
                    {item.props.label ? item.props.label : `Tab ${[index]}`}
                  </Typography>

                  {item.props.notification ? (
                    <> {renderCountBadge(item.props.notification)}</>
                  ) : null}
                </Box>
              }
            />
          ))}
          {addButton}
        </Tabs>
        {headerAction && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: 'auto',
              pr: 1.5,
            }}
          >
            {headerAction}
          </Box>
        )}
      </Box>
      <Box
        sx={{
          overflowY: 'auto',

          ...sxPanel,
        }}
        className="scrollbar"
      >
        {arrayChildren[activeValue]}
      </Box>
    </Box>
  )
}

export default AdxTabsBadge
